/** Import react/libraries section **/
import React, { useEffect, useState, useCallback } from 'react';

/** Import helpers section **/
import { toast } from 'react-toastify';
import {
  getCompaniesService,
  deleteCompanyService
} from '../../api/services/companies-services';

/** Import resources section **/

/** Import component section **/
import Modal from '../../components/Modal';
import CompanyModal from './CompanyModal';
import CompaniesView from './CompaniesView';

const companyModel = {
  id: null,
  name: '',
  legal_name: '',
  federal_register: '',
  legal_representative: '',
  contact_name: '',
  phone: '',
  email: '',
  cell_phone: ''
};

const CompaniesComponent = () => {
  const [originalData, setOriginalData] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [modalMode, setModalMode] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const getCompanies = useCallback(() => {
    setLoading(true);
    getCompaniesService()
      .then((response) => {
        setCompanies(response);
        setOriginalData(response);
      })
      .catch((error) => {
        console.error(
          'Companies component - Error requesting companies list: ',
          error
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getCompanies();
  }, [getCompanies]);

  const handleOnUpdateList = (selectedCompany) => {
    getCompanies();
    handleOnModalClose();
  };

  const handleOnFilterBy = (filterVal) => {
    let filteredItems;

    if (!filterVal || filterVal.length === 0) {
      filteredItems = [...originalData];
    } else {
      const filteringText = filterVal
        ?.toLowerCase()
        ?.normalize('NFD')
        ?.replace(/[\u0300-\u036f]/g, '');

      filteredItems = originalData.filter((item) => {
        const field1 = item.name
          ?.toString()
          ?.toLowerCase()
          ?.normalize('NFD')
          ?.replace(/[\u0300-\u036f]/g, '');
        const field2 = item.legal_name
          ?.toString()
          .toLowerCase()
          ?.normalize('NFD')
          ?.replace(/[\u0300-\u036f]/g, '');
        const field3 = item.federal_register
          ?.toString()
          .toLowerCase()
          ?.normalize('NFD')
          ?.replace(/[\u0300-\u036f]/g, '');
        const field4 = item.legal_representative
          ?.toString()
          .toLowerCase()
          ?.normalize('NFD')
          ?.replace(/[\u0300-\u036f]/g, '');

        return (
          field1.match(filteringText) ||
          field2.match(filteringText) ||
          field3.match(filteringText) ||
          (field4.match(filteringText) && true)
        );
      });
    }

    setCompanies(filteredItems);
  };

  const handleOnAddCompany = () => {
    setSelectedCompany(Object.assign({}, companyModel));
    setModalMode('company');
  };

  const handleOnEditCompany = (row) => {
    let item = Object.assign({}, row);
    setSelectedCompany(item);
    setModalMode('company');
  };

  const handleOnModalClose = () => {
    setSelectedCompany(null);
    setModalMode(null);
  };

  const handleOnDeleteCompany = (row) => {
    setSelectedCompany(row);
    setModalMode('delete');
  };

  const handleOnDeleteConfirm = () => {
    deleteCompanyService({ id: selectedCompany.id })
      .then(() => {
        getCompanies();
        toast.success('Companía borrada');
      })
      .catch((error) => {
        toast.error('Error, no se puede borrar al compañía.');
      })
      .finally(() => {
        setSelectedCompany(null);
        setModalMode(null);
      });
  };

  return (
    <>
      <CompaniesView
        loading={loading}
        companies={companies}
        onFilterBy={handleOnFilterBy}
        onAddCompany={handleOnAddCompany}
        onEditCompany={handleOnEditCompany}
        onDeleteCompany={handleOnDeleteCompany}
      />
      {selectedCompany && modalMode === 'company' && (
        <CompanyModal
          companyData={selectedCompany}
          onClose={handleOnModalClose}
          onUpdateList={handleOnUpdateList}
        />
      )}
      {selectedCompany && modalMode === 'delete' && (
        <Modal
          open={true}
          onClose={handleOnModalClose}
          onConfirm={handleOnDeleteConfirm}
          title="Borrar compañía"
        >
          {'¿Estas seguro que quieres borrar la compañía ' +
            selectedCompany.name +
            '?'}
        </Modal>
      )}
    </>
  );
};

export default CompaniesComponent;
